import React, { Component } from "react";
import { Link } from "react-router-dom";

class Slice extends Component {
  render() {
    return (
      <div
        className={"slice" + (this.props.active ? " expanded" : "")}
        onClick={() => this.props.onRequest()}
      >
        {this.props.active + ""}
        <img src={this.props.img} alt="" />
        <div className="slice-overlay" />
        <p className="vertical-text">{this.props.name}</p>
        <div className="horiz-container">
          <p className="item-name">{this.props.name}</p>
          <Link to={`/shop/category/${this.props.id}`}>
            <button className="blue-o-btn">CHECK IT NOW!</button>
          </Link>
        </div>
      </div>
    );
  }
}

export default Slice;



// WEBPACK FOOTER //
// ./src/components/Slice.js